import React from 'react';

interface PrincipleBlockProps {
  variant: 'full' | 'compact';
  number: string;
  title: string;
  body: string;
  example?: string;
}

const PrincipleBlock: React.FC<PrincipleBlockProps> = ({ variant, number, title, body, example }) => {
  if (variant === 'compact') {
    return (
      <div className="p-6 border border-grid-line">
        <div className="font-mono text-sm text-command-amber mb-2">{number}</div>
        <h3 className="text-lg font-semibold text-signal-white mb-2">{title}</h3>
        <p className="text-steel text-sm leading-relaxed mb-0">{body}</p>
      </div>
    );
  }
  return (
    <div className="p-8 border border-grid-line">
      <div className="font-mono text-2xl text-command-amber mb-4">{number}</div>
      <h3 className="text-2xl font-bold text-signal-white mb-4">{title}</h3>
      <p className="text-steel leading-relaxed mb-6">{body}</p>
      {example && (
        <div className="border-t border-grid-line pt-4">
          <div className="font-mono text-xs text-command-amber uppercase tracking-[0.15em] mb-2">Example</div>
          <p className="text-steel text-sm">{example}</p>
        </div>
      )}
    </div>
  );
};

export default PrincipleBlock;
